import { Component, Injector, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { practitionerI } from 'app/core/interfaces/practitioner';
import { EncounterService } from 'app/core/http/services/encounter.service';
import { Encounter } from 'app/core/interfaces/encounter';
import { BaseComponent } from 'app/modules/shared/components/base.component';

@Component({
  selector: 'page-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
})
export class PractitionerCalendarComponent extends BaseComponent implements OnInit {
  public title = 'Agenda';
  public specialtys: any[] = [];
  public practitioners: any[] = [];
  public orgnizations: any[] = [];
  public resultado: practitionerI[] = [];
  public form: FormGroup;
  public practitionerLogged: any = {};
  public encounters: Encounter[] = [];
  public filteredEncounters: Encounter[] = [];
  public selectedOrganization: string = '';
  public selectedSpecialty: string = '';

  constructor(private fb: FormBuilder, private encounterService: EncounterService, private injector: Injector) {
    super(injector);
    this.form = this.fb.group({
      orgnizations: ['', Validators.nullValidator],
      speciality: ['', Validators.nullValidator],
    });
  }

  ngOnInit(): void {
    const userLogged = this.getUserLogged();

    this.practitionerLogged = {
      practitioner_id: userLogged.id,
      name: userLogged.name,
      email: userLogged?.email,
    };

    this.getEncountersByPractitioner();
  }

  pesquisar() {
    const formValues = this.form.value;

    this.getEncountersByPractitioner();
  }

  getEncountersByPractitioner() {
    const practitioner_id = this.getUserLogged().id;

    this.encounterService.listByPractitionerNew(practitioner_id).subscribe({
      next: (encounter: Encounter[]) => {
        this.encounters = encounter ?? [];
        this.filteredEncounters = encounter;
        this.loadFilters();
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  loadFilters() {
    const organizationsSet = new Set<string>();
    const specialtiesSet = new Set<string>();

    this.encounters.forEach((encounter) => {
      if (encounter.organization && encounter.organization.name) {
        organizationsSet.add(encounter.organization.name);
      }
      if (encounter.specialty) {
        specialtiesSet.add(encounter.specialty);
      }
    });

    this.orgnizations = Array.from(organizationsSet).map((name) => ({ name }));
    this.specialtys = Array.from(specialtiesSet).map((specialty) => ({ name: specialty }));
  }

  filterEncounters() {
    const formValues = this.form.value;
    this.filteredEncounters = this.encounters.filter((encounter) => {
      return (
        (!formValues.orgnizations || encounter.organization?.name === formValues.orgnizations) &&
        (!formValues.speciality || encounter.specialty === formValues.speciality)
      );
    });
  }

  clearFilters() {
    this.form.reset();
    this.filteredEncounters = this.encounters;
  }
}
